import { FC } from "react";

import { cn } from "@/ui/lib";
import { BASE_INPUT_CLASSES, INPUT_ERROR_CLASSES } from "../forms.config";
import { TTextareaFieldProps } from "./Textarea.config";

export const TextareaField: FC<TTextareaFieldProps> = ({
  value,
  disabled,
  error,
  className,
  ...props
}) => (
  <textarea
    {...props}
    aria-invalid={!!error}
    value={value}
    disabled={disabled}
    className={cn(
      BASE_INPUT_CLASSES,
      "px-3 py-2 resize-y min-h-[64px]",
      "focus:ring-focus-secondary",
      error && INPUT_ERROR_CLASSES,
      className,
    )}
  />
);

TextareaField.displayName = "TextareaField";
